import type { TabCounts } from '../../types'

type TopicTab = 'active' | 'solved'

interface Props {
  activeTab: string
  counts: TabCounts
  onTabChange: (tab: string) => void
}

const TABS: { key: TopicTab; label: string }[] = [
  { key: 'active', label: 'Active' },
  { key: 'solved', label: 'Solved' },
]

export default function TopicTabNav({ activeTab, counts, onTabChange }: Props) {
  const getCount = (key: TopicTab): number => counts[key] || 0

  return (
    <div className="flex border-b border-[#351E1D]/10 mb-4">
      {TABS.map(tab => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={`relative px-5 py-3 font-medium transition-colors ${
            activeTab === tab.key
              ? 'text-text-primary border-b-2 border-charcoal'
              : 'text-text-secondary hover:text-text-primary'
          }`}
          style={{ fontSize: '14px' }}
        >
          {tab.label}
          <span className={`ml-2 inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full font-semibold ${
            activeTab === tab.key
              ? 'bg-[#351E1D]/10 text-text-primary'
              : 'bg-[#351E1D]/10 text-text-secondary'
          }`} style={{ fontSize: '12px' }}>
            {getCount(tab.key)}
          </span>
        </button>
      ))}
    </div>
  )
}
